import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { SubmitFormUseCase } from './SubmitFormUseCase';

export const initializeZendeskUseCases = (container: Container) => {
    container.register(DI.USECASES.IZendeskSubmitFormUseCase, {
        useClass: SubmitFormUseCase,
    });
};
